var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { class: _vm.containerClasses }, [
    _c("dt", { staticClass: "text-sm leading-5 font-medium text-gray-500" }, [
      _vm._v(" " + _vm._s(_vm.title) + " "),
    ]),
    _c(
      "dd",
      { staticClass: "mt-1 text-sm leading-5 text-gray-900" },
      [
        _vm._t("default", function () {
          return [_vm._v(" " + _vm._s(_vm.content || _vm.noInformation) + " ")]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }